import { render, staticRenderFns } from "./SortByFilter.vue?vue&type=template&id=09f0dc36"
import script from "./SortByFilter.vue?vue&type=script&lang=js"
export * from "./SortByFilter.vue?vue&type=script&lang=js"
import style0 from "./SortByFilter.vue?vue&type=style&index=0&id=09f0dc36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports